import api from "./axiosInstance";

export const getPixels = async () => {
  const res = await api.get("api/v1/pixels/");
  return res.data;
};

export const getAllPixels = async () => {
  const res = await api.get("api/v1/pixels/?limit===999");
  return res.data;
};

export const getPixelsByEventId = async (eventId) => {
  const res = await api.get(`api/v1/pixels/?event=${eventId}/`);
  return res.data;
};

export const createPixels = async (payload) => {
  const res = await api.post(`api/v1/pixels/`, payload);
  return res.data;
};

export const updatePixels = async (id, payload) => {
  const res = await api.patch(`api/v1/pixels/${id}/`, payload);
  return res.data;
};

export const deletePixels = async (id) => {
  await api.delete(`api/v1/pixels/${id}/`);
};
